<template>
	<span>×</span>
</template>